import { render, staticRenderFns } from "./BulkShipmentBoxInfo.vue?vue&type=template&id=d8a2251e&scoped=true&"
import script from "./BulkShipmentBoxInfo.vue?vue&type=script&lang=ts&"
export * from "./BulkShipmentBoxInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BulkShipmentBoxInfo.vue?vue&type=style&index=0&id=d8a2251e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a2251e",
  null
  
)

export default component.exports